import React, { Component } from "react"
import Link from '../utils/link'
import { graphql } from 'gatsby'
import SEO from "../components/seo"
import Drummond from '../assets/images/drummond.jpg'

class ProjectsPage extends Component {

  render() {
    
    const { page } = this.props.data

    return (
      <>
        <SEO title={page.seo.title} bodyClass='projects' description={page.seo.metaDesc} />
        <section className='page'>
          <div className='page__inner'>
            <div className='projects__items'>
              { page.Projects.projects.map((el, i) => {
                return (
                  <div className='projects__item' key={i}>
                    <img src={el.image.sourceUrl} alt={el.title} />
                    <p>{el.title}</p>
                    { el.link && <Link className='projects__link' to={el.link}></Link> }
                  </div>
                )
              })}
            </div>
          </div>
        </section>
      </>
    )
  }
}

export default ProjectsPage

export const projectsQuery = graphql`
  query {
    page: wpPage(slug: { eq: "projects" }){
      title
      seo {
        title
        metaDesc
      }
      Projects {
        projects {
          image {
            sourceUrl
          }
          title
          link
        }
      }
    }
  }
`
